'use strict';

var PersonalContactInfoUpdateUtil = function PersonalContactInfoUpdateUtil($resource, $log) {

	return {

		getUpdateContactInfoJson: getUpdateContactInfoJson

	};

	function getUpdateContactInfoJson(flowName, emailAddress, domesticCntryCd, intlCntryCode) {
		var phoneNumber = '';
		var intlNumber = '';
		var cntryCode = '';
		var domesticCntryCode = '';
		var home = '';
		if ($("#phoneNumberIdD").is(":visible")) {
			phoneNumber = $("#phoneNumberIdD").val();
			var temp = domesticCntryCd;
			domesticCntryCode = domesticCntryCd.substring(0, 2);
		}
		if ($("#intlNumberIdD").is(":visible")) // This condition becomes true when the domestic number being changed to INTLNumber
		{
			intlNumber = $("#intlNumberIdD").val();
			var temp = domesticCntryCd;
			cntryCode = temp.substring(0, 2);
		}

		if ($("#phoneNumberIdI").is(":visible")) {
			phoneNumber = $("#phoneNumberIdI").val();
			var temp = intlCntryCode;
			domesticCntryCode = intlCntryCode.substring(0, 2);
		}
		if ($("#intlNumberIdI").is(":visible")) {
			const temp = intlCntryCode;
			intlNumber = $("#intlNumberIdI").val();
			cntryCode = temp.substring(0, 2);
		}
		if ($("#homeNumberId").is(":visible") && $("#homeNumberId").is(":visible")) {
			home = $("#homeNumberId").val();
		}
		/*if($("#phoneNumberIdD").is(":visible"))
		{
		phoneNumber=  $("#phoneNumberIdD").val();
		var temp = domesticCntryCd;
		domesticCntryCode= domesticCntryCd.substring(0,2);
		}
	if($("#phoneNumberIdI").is(":visible")) // This condition becomes true when the domestic number being changed to INTLNumber
	{
		intlNumber=$("#phoneNumberIdI").val();
		var temp = intlCntryCode
		 cntryCode= temp.substring(0,2);
		 
	}
	
	if($("#phoneNumberIdI").is(":visible"))
	{
	phoneNumber=$("#phoneNumberIdI").val();
	var temp = domesticCntryCd;
	domesticCntryCode= domesticCntryCd.substring(0,2);
	}
	if($("#intlNumberIdI").is(":visible")) // This condition becomes true when the domestic number being changed to INTLNumber
	{
	intlNumber=$("#intlNumberIdI").val();
	var temp = intlCntryCode
	 cntryCode= temp.substring(0,2);
	}*/

		var updatePersonalContactData = {
			"email": emailAddress,
			"phoneNumber": phoneNumber,
			"cntryCode": cntryCode,
			"domesticCntryCode": domesticCntryCode,
			"intlNumber": intlNumber,
			"flowName": flowName,
			"home": home
		};
		return updatePersonalContactData;

	};
}
PersonalContactInfoUpdateUtil.$inject = ['$resource', '$log'];
export default PersonalContactInfoUpdateUtil;